import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { withRouter } from "../../../App";
import { connect, useDispatch } from "react-redux";
import { dateFormat } from "../../../utils/date";
import swal from "sweetalert";
import {Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { del,get,post,put,uploadTemplate } from "../../../services/api";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import Select from "react-select";

const TemplateList = ({ title, token }) => {

  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [docs, setdocs] = useState([]);
  const [preview,setPreview] = useState();
  const [sastoken, setsastoken] = useState([]);

  const [file,setfile]= useState();
  const [filename,setfilename]= useState();

  
  useEffect(()=>{
    getDocs();
    getSasToken();
  },[])

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsloading(true);
    if (!preview?._id) {
      toast.error("Please select template.");
      setIsloading(false);
      return;
    }
    if (!file) {
      toast.error("Please select a file to upload.");
      setIsloading(false);
      return;
    }
  
    try {
      const response = await uploadTemplate(file, token);
  
      // Prepare body for API request
      const body = {
        fileLink: response?.url,
      };
  
      // If a template is selected (updating an existing one)
      if (preview?._id) {
        await put(`/api/template/${preview._id}`, body, token);
        toast.success("Template updated successfully.");
      }
      
      setfilename();
      setfile();
      setIsloading(false);
    } catch (error) {
      console.error("Error updating template:", error);
      toast.error("Failed to update template.");
      setIsloading(false);
    }
  };
  
  const getSasToken = async () => {
    const response = await get('/api/template/generate-sas-token', token);
    setsastoken(response?.sasToken)
  }

  const getDocs = async () => {
    const response = await get('/api/template', token);
    setdocs(response)
  }

  const downloadFile = (url, filename) => {
    setIsloading(true);
    fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response.blob();
        })
        .then((blob) => {
            const blobURL = window.URL.createObjectURL(blob);
            const tempLink = document.createElement("a");
            tempLink.href = blobURL;
            tempLink.download = filename || "downloaded-file"; // Set the desired filename
            tempLink.click();
            window.URL.revokeObjectURL(blobURL);
            setIsloading(false);
            toast.success("Files downloaded")
        })
        .catch((error) => {
            console.error("Error downloading file:", error);
        });
}


  

  return (
    <>
      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
            
            <div className="filter-section p-3 pt-3">
            <label >
              Select Template :
              
            </label>
            <Select
                menuPosition="fixed"
                options={
                    docs.map(l=> {
                      return { label: l.fileName, value: l._id }
                    })
                  }
                onChange={(selectedOption) =>
                  
                  setPreview(selectedOption ? docs.filter(d=> d._id === selectedOption.value)[0] : {})
                }
              />
            </div>
            
            <div className="card profile-card card-bx m-b30">
              <div className="card-header">
                <h6 className="title">File Preview</h6>
              </div>
              <form className="profile-form">
                <div className="card-body">
                  <div className="row">
                  {isPreviewLoading && <div className="loading-overlay"><Spinner animation="grow" /></div>}
                   
                  {preview?.fileLink && 
                  <div style={{ width: '100%', height: '100vh', border: 'none' }}>
        {!isPreviewLoading && <button type="button" onClick={()=>{downloadFile(preview?.fileLink+"?"+sastoken, preview?.fileName)}} className="btn btn-primary me-1">
        <i className="fa-solid fa-download me-2" />{isLoading ? <Spinner size="sm"/> : 'Download'}
        </button>}
                
                   <iframe
                           src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(preview?.fileLink+"?"+sastoken)}`}
                          
                            style={{ width: '100%', height: '100%', border: 'none', display: isPreviewLoading ? 'none' : 'block' }}
                            onLoad={() => setIsPreviewLoading(false)}
                            
                            allowFullScreen></iframe>
                            
                          
                        </div>}

                    
                  </div>
                </div>
                <div className="card-footer">
                <div className="row">
                        
                        <div className="col-xl-12 mb-6">
                          <label className="form-label">
                            Select New Version
                          </label>
                          <input className="form-control" type="file"  onChange={(e)=> { setfile(e.target.files[0])}}/>
                         
                                                    
                        </div>
                        <div className="col-xl-6 mb-6 mt-4">
                        <button className="btn btn-primary me-1" 
                          onClick={onSubmit} 
                        >
                           {isLoading ? <Spinner size="sm"/> : 'Upload'}
                        </button>              
                        </div>
                        
                       
                       

                        </div>

                {/* <DropFile token={token} onSubmit={onSubmit}/> */}
                </div>
                </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
  };
};

export default withRouter(connect(mapStateToProps)(TemplateList));
